(() => {
  if (window.__giftOverlaySingle) return;
  window.__giftOverlaySingle = true;

  const CHECKOUT_URL = '{{ routes.checkout_url }}';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  // --- find overlay parts (fresh each time) ---
  function parts() {
    const overlay = $('[data-gift-overlay]');
    if (!overlay) return {};
    return {
      overlay,
      dialog:    overlay.querySelector('.gift-overlay__dialog'),
      errorEl:   overlay.querySelector('[data-gift-error]'),
      wrap:      overlay.querySelector('[data-gift-count-wrap]'),
      qty:       overlay.querySelector('[data-gift-count]'),
      rYes:      overlay.querySelector('input[name="overlay_is_gift"][value="Yes"]'),
      rNo:       overlay.querySelector('input[name="overlay_is_gift"][value="No"]')
    };
  }

  // --- ensure attributes go with the checkout form POST ---
  function setHiddenGiftInputs(choice, num) {
    const form = $('.quick-cart__form');
    if (!form) return;

    let isGift     = form.querySelector('input[name="attributes[Is gift]"]');
    let giftCount  = form.querySelector('input[name="attributes[Gift count]"]');

    if (!isGift) {
      isGift = document.createElement('input');
      isGift.type = 'hidden';
      isGift.name = 'attributes[Is gift]';
      form.appendChild(isGift);
    }
    if (!giftCount) {
      giftCount = document.createElement('input');
      giftCount.type = 'hidden';
      giftCount.name = 'attributes[Gift count]';
      form.appendChild(giftCount);
    }

    isGift.value = choice || '';
    giftCount.value = choice === 'Yes' ? String(num || 1) : '';
  }

  // --- open / close / qty visibility ---
  function openOverlay() {
    const { overlay, dialog, errorEl, wrap, qty, rYes, rNo } = parts();
    if (!overlay) return;

    // reset
    if (rYes) rYes.checked = false;
    if (rNo)  rNo.checked  = false;
    if (qty)  { qty.value = ''; qty.removeAttribute('value'); }
    if (wrap) wrap.hidden = true;
    if (errorEl) errorEl.hidden = true;

    rYes?.setAttribute('autocomplete','off');
    rNo?.setAttribute('autocomplete','off');
    qty?.setAttribute('autocomplete','off');

    overlay.hidden = false;
    overlay.closest('.quick-cart__container')?.classList.add('is-dimmed');
    dialog?.focus();
    requestAnimationFrame(() => updateQtyVisibility());
  }

  function closeOverlay() {
    const { overlay } = parts();
    if (!overlay) return;
    overlay.hidden = true;
    overlay.closest('.quick-cart__container')?.classList.remove('is-dimmed');
  }

  function updateQtyVisibility() {
    const { wrap, qty, rYes } = parts();
    if (!wrap) return;
    const show = !!rYes?.checked;
    wrap.hidden = !show;
    if (!show && qty) { qty.value = ''; qty.removeAttribute('value'); }
  }

  // --- save attributes to cart (best-effort, not critical) ---
  async function saveAttrsFast(choice, num) {
    const payload = {
      attributes: {
        'Is gift': choice,
        'Gift count': choice === 'Yes' ? String(num) : ''
      }
    };
    try {
      await Promise.race([
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        }),
        new Promise(res => setTimeout(res, 400))
      ]);
    } catch (_) {
      // ignore – checkout form still carries the hidden inputs
    }
  }

  // --- submit the real cart form as checkout ---
  function submitCheckoutForm() {
    const form = $('.quick-cart__form');
    if (!form) { window.location.assign(CHECKOUT_URL); return; }

    window.__giftBypass = true;

    const tmp = document.createElement('button');
    tmp.type = 'submit';
    tmp.name = 'checkout';
    tmp.style.display = 'none';
    form.appendChild(tmp);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(tmp);
    } else {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      form.appendChild(hidden);
      form.submit();
    }
    setTimeout(() => tmp.remove(), 0);
  }

  // --- detect the checkout button in the drawer ---
  function isCheckoutTarget(t) {
    const btn = t.closest('button[name="checkout"], input[name="checkout"][type="submit"]');
    if (!btn) return false;

    const overlay = document.querySelector('[data-gift-overlay]');
    if (!overlay) return false;

    const drawer = overlay.closest('.quick-cart__container')
               || overlay.closest('[data-cart-drawer]')
               || overlay.closest('[data-section-id]')
               || document;

    return drawer.contains(btn);
  }

  // --- intercept clicks / submits to open overlay ---
  function intercept(e) {
    if (window.__giftBypass) return;
    if (!isCheckoutTarget(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
    openOverlay();
  }

  ['pointerdown', 'click'].forEach(evt => {
    document.addEventListener(evt, intercept, true);
  });

  document.addEventListener('submit', (e) => {
    if (window.__giftBypass) return;
    const s = e.submitter || document.activeElement;
    if (!(s && s.name === 'checkout')) return;
    if (!isCheckoutTarget(s)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
    openOverlay();
  }, true);

  // --- overlay interactions (delegated) ---
  document.addEventListener('click', async (e) => {
    const { overlay, errorEl, qty, rYes, rNo } = parts();
    if (!overlay || overlay.hidden) return;

    // close
    if (e.target.closest('[data-gift-close]') || e.target.matches('.gift-overlay__backdrop')) {
      closeOverlay();
      return;
    }

    // + / −
    if (e.target.closest('[data-gift-plus]')) {
      const cur = parseInt(qty?.value || '0', 10) || 0;
      if (qty) qty.value = String(Math.max(1, cur + 1));
      return;
    }
    if (e.target.closest('[data-gift-minus]')) {
      const cur = parseInt(qty?.value || '0', 10) || 0;
      if (qty) qty.value = cur <= 1 ? '' : String(cur - 1);
      return;
    }

    // continue → validate, set hidden fields, save, checkout
    if (e.target.closest('[data-gift-continue]')) {
      const choice = rYes?.checked ? 'Yes' : (rNo?.checked ? 'No' : null);
      const n = parseInt(qty?.value || '0', 10);

      const valid = choice && (
        choice === 'No' ||
        (choice === 'Yes' && Number.isInteger(n) && n >= 1)
      );

      if (!valid) {
        if (errorEl) errorEl.hidden = false;
        return;
      }

      // GUARANTEE: send these with the checkout POST
      setHiddenGiftInputs(choice, n);

      // best-effort sync to cart
      saveAttrsFast(choice, n);

      closeOverlay();
      submitCheckoutForm();
    }
  });

  // radios show/hide qty
  document.addEventListener('change', (e) => {
    const { overlay } = parts();
    if (!overlay || overlay.hidden) return;
    if (e.target?.name === 'overlay_is_gift') updateQtyVisibility();
  });
})();